import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		id: 'eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title',
		defaultMessage: 'Something went wrong while updating user properties.',
		description: 'Helper text for updating user properties error flag',
	},
});
